import {Chips, ChipsOption} from 'platform/components';
import {match} from 'ts-pattern';

import i18n from '@dms/i18n';

import {buildArray} from 'shared/web';

import {CommunicationChannelFilter} from '../types/CommunicationChannelFilter';

interface CommunicationChannelChipsProps {
  filterCounts: Record<CommunicationChannelFilter, number>;
  activeFilter: CommunicationChannelFilter;
  onFilterChange: (filter: CommunicationChannelFilter) => void;
  size?: 'small' | 'default';
}

export function CommunicationChannelChips(props: CommunicationChannelChipsProps) {
  // Calls only where there are any, so a tenant without telephony sees no empty chip; kept while
  // selected, so a thread whose last call went away still shows why it is empty.
  const filterOptions = buildArray<ChipsOption>()
    .add({value: 'all', label: i18n.t('general.labels.all'), suffix: `(${props.filterCounts.all})`})
    .add({
      value: 'email',
      label: i18n.t('general.labels.email'),
      suffix: `(${props.filterCounts.email})`,
    })
    .add({value: 'sms', label: i18n.t('general.labels.sms'), suffix: `(${props.filterCounts.sms})`})
    .add({
      value: 'whatsapp',
      label: i18n.t('general.labels.whatsapp'),
      suffix: `(${props.filterCounts.whatsapp})`,
    })
    .when(props.filterCounts.call > 0 || props.activeFilter === 'call', {
      value: 'call',
      label: i18n.t('page.telephony.thread.callsFilter'),
      suffix: `(${props.filterCounts.call})`,
    });

  return (
    <Chips
      value={[props.activeFilter]}
      size={props.size ?? 'small'}
      options={filterOptions}
      onChange={(value) =>
        match(value?.[0])
          .with('all', 'email', 'sms', 'whatsapp', 'call', (filter) => props.onFilterChange(filter))
          .otherwise(() => {})
      }
    />
  );
}
